class FeaturedBlocks extends HTMLElement {
	constructor() {
		super();
		this.init();
	}

	init() {
		// Event listeners voor responsive gedrag
		this.handleResize();
		window.addEventListener('resize', this.handleResize.bind(this));
		
		// Smooth scroll voor buttons
		this.initSmoothScroll();
		
		// Accessibility verbeteringen
		this.initAccessibility();
		
		// Hover effecten
		this.initHoverEffects();
	}

	handleResize() {
		// Responsive gedrag wordt nu gedaan via CSS
		// Dit kan uitgebreid worden voor meer complexe responsive gedrag
	}

	initSmoothScroll() {
		const buttons = this.querySelectorAll('.featured-blocks__btn');
		buttons.forEach(button => {
			button.addEventListener('click', (e) => {
				// Voeg smooth scroll toe als de link naar een sectie op dezelfde pagina verwijst
				const href = button.getAttribute('href');
				if (href && href.startsWith('#')) {
					e.preventDefault();
					const target = document.querySelector(href);
					if (target) {
						target.scrollIntoView({
							behavior: 'smooth',
							block: 'start'
						});
					}
				}
			});
		});
	}

	initAccessibility() {
		// Voeg ARIA labels toe voor betere toegankelijkheid
		const cards = this.querySelectorAll('.featured-blocks__card');
		cards.forEach((card, index) => {
			card.setAttribute('aria-label', `Featured product ${index + 1}`);
		});
	}

	initHoverEffects() {
		// Voeg extra hover effecten toe voor betere UX
		const cards = this.querySelectorAll('.featured-blocks__card');
		cards.forEach(card => {
			card.addEventListener('mouseenter', () => {
				card.style.willChange = 'transform';
			});
			
			card.addEventListener('mouseleave', () => {
				card.style.willChange = 'auto';
			});
		});
	}
}

// Registreer de custom element
customElements.define('featured-blocks', FeaturedBlocks);
